import { Button } from '@/components/ui/button'
import { cn } from '@/lib/utils'
import { useTranslation } from 'react-i18next'
import { ScreenHeading } from './screen-heading'

type Props = {
	title: string
	subtitle?: string
	current: boolean | null
	onSubmit: (value: boolean) => void
	isSubmitting: boolean
	illustrationSrc?: string
}

export function YesNoScreen({ title, subtitle, current, onSubmit, isSubmitting, illustrationSrc }: Props) {
	const { t } = useTranslation()

	return (
		<>
			{illustrationSrc && <img src={illustrationSrc} alt="" className="mx-auto max-h-40 w-auto" />}
			<ScreenHeading title={title} subtitle={subtitle} />
			<div className="grid grid-cols-2 gap-3">
				<Button
					variant={current === true ? 'default' : 'outline'}
					disabled={isSubmitting}
					onClick={() => onSubmit(true)}
					className={cn(
						'h-14',
						current === true && 'bg-brand-600 hover:bg-brand-700 text-white border-brand-600',
					)}
				>
					{t('common.yes')}
				</Button>
				<Button
					variant={current === false ? 'default' : 'outline'}
					disabled={isSubmitting}
					onClick={() => onSubmit(false)}
					className={cn(
						'h-14',
						current === false && 'bg-brand-600 hover:bg-brand-700 text-white border-brand-600',
					)}
				>
					{t('common.no')}
				</Button>
			</div>
		</>
	)
}
